import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { NavLink, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import MaterialPagination from "../../styles/materialPagination";
import Notification from "../../elements/notification/Notification";
import PayoutList from "../../payouts/client/PayoutList";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledBatchesDetailsWrapper } from "../styledBatches";
import PageSpinner from "../../elements/spinner/PageSpinner";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import TransactionFilter from "../../elements/transactions/TransactionFilter";
import TransactionExportButton from "../../elements/transactions/transactionExportButton";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const BatchesDetailsContainer = ({ match }) => {
  const { t } = useTranslation("batchesPage");

  const [payouts, setPayouts] = useState(null);
  const [batch, setBatch] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true),
    "status.value": checkFilterItem(history, "status.value", null),
    "id": checkFilterItem(history, "id", null),
    "referenceId": checkFilterItem(history, "referenceId", null),
    "processingId": checkFilterItem(history, "processingId", null),
    "exchangeId": checkFilterItem(history, "exchangeId", null),
    "note": checkFilterItem(history, "note", null),
    "processedAmount[gte]": checkFilterItem(history, "processedAmount[gte]", null, true),
    "processedAmount[lte]": checkFilterItem(history, "processedAmount[lte]", null, true),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "paymentSystem.name": checkFilterItem(history, "paymentSystem.name", null),
    "connection.service.name": checkFilterItem(history, "connection.service.name", null),
    "connection.project.name": checkFilterItem(history, "connection.project.name", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchBatch = () => {
    axios.get("/api/batches/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setBatch(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const fetchPayouts = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/payouts" + filterUrl + "&batches.id=" + match.params.id + "&order[note]=ASC",
      userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setPayouts(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  // TODO Add pusher

  useEffect(() => {
    fetchBatch();
  }, []);

  useEffect(() => {
    fetchPayouts();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  if (!payouts || !batch) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledBatchesDetailsWrapper>
        <StyledContentWrapper
          height="auto"
          className="batches-details-head"
        >
          <Helmet>
            <title>Выплаты • eXsoft.io</title>
          </Helmet>
          <GoToBackButton
            pt="20"
            pb="30"
            handler={() => {history.goBack();}}
          />
          <div className="batches-info">
            <div
              className="batches-info__name batches-info__row"
              title="Название"
            >
              <span className="icon-light-reload" />
              <p>
                {batch.name}
              </p>
            </div>
            <div
              className="batches-info__date batches-info__row"
              title="Дата создания"
            >
              <span className="icon-light-calendar" />
              {TimestampToDateMoment(batch.createDate)}
            </div>
          </div>
          <div className="batches-process">
            <div className="batches-process__row">
              <div>{t("table.batchResult.all")}</div>
              <div>{t("table.batchResult.createWaiting")}</div>
              <div>{t("table.batchResult.created")}</div>
              <div>{t("table.batchResult.processed")}</div>
              <div>{t("table.batchResult.failed")}</div>
              <div>{t("table.batchResult.pending")}</div>
            </div>
            <div className="batches-process__row">
              <div data-title={t("table.batchResult.all")}>{batch.countOfAll}</div>
              <div data-title={t("table.batchResult.createWaiting")}>{batch.countOfCreateWaiting}</div>
              <div data-title={t("table.batchResult.created")}>{batch.countOfCreated}</div>
              <div data-title={t("table.batchResult.processed")}>{batch.countOfProcessed}</div>
              <div data-title={t("table.batchResult.failed")}>{batch.countOfFailed}</div>
              <div data-title={t("table.batchResult.pending")}>{batch.countOfPending}</div>
            </div>
          </div>
        </StyledContentWrapper>
        <StyledContentWrapper height="auto">
          <div className="payouts-head">
            <div className="payouts-head__left">
              <TransactionFilter
                filterData={filterData}
                setFilterData={setFilterData}
                direction="payouts"
              />
              <TransactionExportButton
                direction="payouts"
                filterData={{ ...filterData, "batches.id": match.params.id }}
              />
              <ItemsPerPageSelect
                itemsPerPage={filterData.itemsPerPage}
                setItemsPerPage={(data) => setFilterData({
                  ...filterData,
                  "itemsPerPage": data,
                  page: 1
                })}
              />
            </div>
          </div>
          <PayoutList payouts={payouts} />
          {totalPageCount &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledContentWrapper>
      </StyledBatchesDetailsWrapper>
    </>
  );
};

export default BatchesDetailsContainer;